import { List, Map as ImmutableMap, Record } from 'immutable';
import type { RecordOf, RecordFactory } from 'immutable';

import type { QcsSyncResourceStoreProps } from 'data/qcsSyncResourceTypes';

export type FI_AGGREGATOR = 'FDS' | 'PLAID';

type InstitutionFormFieldProps = {
  key: string,
  name: string,
  type: string,

  displayOrder: number,
  displayLabel: string,
  helpText: ?string,
  maxLength: ?number,
};
export type InstitutionFormField = RecordOf<InstitutionFormFieldProps>;
export const mkInstitutionFormField: RecordFactory<InstitutionFormFieldProps> =
  new Record({
    key: 'unknown',
    name: 'unknown',
    type: 'unknown',
    displayOrder: 0,
    displayLabel: 'unknown',
    helpText: null,
    maxLength: null,
  });

type InstitutionPartnerAuthProps = {
  intuitProperty: string,
  offeringRedirectUri: string,
  partnerAuthUrl: string,
  partnerUid: string,
  fields: List<InstitutionFormField>,
}
export type InstitutionPartnerAuth = RecordOf<InstitutionPartnerAuthProps>;
export const mkInstitutionPartnerAuth: RecordFactory<InstitutionPartnerAuthProps> =
  new Record({
    intuitProperty: 'unknown',
    offeringRedirectUri: 'unknown',
    partnerAuthUrl: 'unknown',
    partnerUid: 'unknown',
    fields: List(),
  });

type InstitutionOfxDataProps = {
  bid: number,
  pid: number,
  name: string,
  contact_url: string,
  contact_phone: string,
  registraction_url: string,
}
export type InstitutionOfxData = RecordOf<InstitutionOfxDataProps>;
export const mkInstitutionOfxData: RecordFactory<InstitutionOfxDataProps> =
  new Record({
    bid: 0,
    pid: 0,
    name: 'unknown',
    contact_url: 'unknown',
    contact_phone: 'unknown',
    registraction_url: 'unknown',
  });

type InstitutionFdsDataProps = {
  id: string,
  name: string,

  contact_url: string,
  contact_phone: string,
  contact_email: string,

  login_url: string,
  formFields: List<InstitutionFormField>,
  ewcLive: boolean,
};
export type InstitutionFdsData = RecordOf<InstitutionFdsDataProps>;
export const mkInstitutionFdsData: RecordFactory<InstitutionFdsDataProps> =
  new Record({
    id: '0',
    name: 'unknown',

    contact_url: 'unknown',
    contact_phone: 'unknown',
    contact_email: 'unknown',

    ewcLive: false,
    login_url: 'unknown',

    formFields: List(),
    partnerAuth: null,
  });

type InstitutionPlaidDataProps = {
  id: ?string,
  name: ?string,
};
export type InstitutionPlaidData = RecordOf<InstitutionPlaidDataProps>;
export const mkInstitutionPlaidData: RecordFactory<InstitutionPlaidDataProps> =
  new Record({
    id: null,
    name: null,
  });


type InstitutionProps = {
  id: string,
  name: string,
  url: string,

  primaryColor: ?string,
  accentColor: ?string,
  accentTextColor: ?string,
  logo: ?string,
  logoUrl: ?string,

  ofx: InstitutionOfxData,
  fds: InstitutionFdsData,
  plaid: InstitutionPlaidData,
}
export type Institution = RecordOf<InstitutionProps>;
export const mkInstitution: RecordFactory<InstitutionProps> =
  new Record({
    id: '0',
    name: 'unknown',
    url: null,

    primaryColor: null,
    accentColor: null,
    accentTextColor: null,
    logo: null,
    logoUrl: null,

    ofx: mkInstitutionOfxData(),
    fds: mkInstitutionFdsData(),
    plaid: mkInstitutionPlaidData(),
  });

type InstitutionStoreProps = QcsSyncResourceStoreProps & {
  suggested: List
}
export type InstitutionsStore = RecordOf<InstitutionStoreProps>;
export const mkInstitutionsStore: RecordFactory<InstitutionStoreProps> =
  new Record({
    resourcesById: ImmutableMap(),
    lastSyncDate: null,

    loadPending: true,
    isLoading: false,

    popularIds: null,
  });



